<template>
  <div>
    <span class="roi-main-group-title"><b>{{label}}</b></span>
    <div
      v-for="(checkboxGroup) in optionsGroupsArray"
      :key="checkboxGroup.groupLabel"
    >
      <span
        class="roi-group-title mt-4"
        v-if="name !== 'R_AGROUP0002'"
      >{{ checkboxGroup.groupLabel }}</span>
      <v-checkbox
        v-for="(checkbox) in checkboxGroup.options"
        multiple
        hide-details="true"
        :key="checkbox.key"
        :value="checkbox.key"
        :input-value="values"
        :label="checkbox.label"
        @change="changed($event,checkbox.key)"
        class="roi-checkbox"
        on-icon="mdi-checkbox-marked-outline"
        color="white"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    label: String,
    name: String,
    options: Object,
    optionGroups: Object,
    value: {
      type:  [String,Array],
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      changedStatus: false,
      changedValues: [],
    };
  },
  computed: {
    optionsGroupsArray() {
      // convert to array ob objects with key and label
      let returnArray = [];
      Object.entries(this.optionGroups).forEach(([key, options]) => {
        let optionsArray = [];
        Object.entries(options).forEach(([key, value]) => {
          optionsArray.push({key: key, label: value});
        });

        returnArray.push({groupLabel: key, options: optionsArray});
      });
      return returnArray;
    },
    optionsArray() {
      // convert to array ob objects with key and label
      let returnArray = [];
      Object.entries(this.options).forEach(([key, value]) => {
        returnArray.push({key: key, label: value});
      });
      return returnArray;
    },
    values() {
      if (this.changedStatus) {
        return this.changedValues;
      } else {
        // else return initial value
        if (Array.isArray(this.value)) {
          return this.value;
        } else {
          // just in case if just one value per url parameter put the single value in an array
          return [this.value];
        }

      }
    }
  },
  methods: {
    changed(value,key) {

      // first call assign the initial values only wich will be reactive is some item is deselected
      if (!this.changedStatus) {
        this.changedValues = value;
      }
      else {
        const index = this.changedValues.indexOf(key);
        if (index > -1) {
          this.changedValues.splice(index, 1);
        } else {
          this.changedValues.push(key);
        }
      }

      this.changedStatus = true;

      this.$emit('input', this.changedValues);

    },
  },
  watch: {
    value: {
      handler(val) {
        this.changedValues = val
      }
    },
  }
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';

.roi-checkbox {
  border-radius: 20px;
  display: table;
  background:#EBEBEB;
  padding:10px 20px;
  &.v-input--is-label-active {
    background: $c-dehn-red;
   label {
     color: $c-dehn-white;
   }
  }
}

</style>
